
      <div class="col-lg-6 col-xs-12">

          <div class="panel panel-default">
              <div class="panel-body">

        <div style="display: block">
          <canvas baseChart
                      [data]="doughnutChartData"
                      [labels]="doughnutChartLabels"
                      [chartType]="doughnutChartType"
                      (chartHover)="chartHovered($event)"
                      (chartClick)="chartClicked($event)"></canvas>
        </div>


      </div>
    </div>

      </div>





// WEBPACK FOOTER //
// ./src/app/report/charts/doughnut-chart/doughnut-chart.component.html